<template>
  <div class="heat-page-container">
    <div class="heat-top-text">
      <span>{{ topFirstText }}</span>
    </div>
    <div class="heat-container-wrapper">
      <div class="split-container">
        <!-- 左侧竖形图片容器 -->
        <div class="left-image-container">
          <img
              src="../../static/series/cutbed/cut_bed.png"
              :alt="imageAlt"
              class="vertical-image image-15"
              @load="handleImageLoad"
          >
          <img class="image-arrow4" src="../../static/series/cutbed/arrow4.png" alt="">
          <div class="left-arrow-image">
            <div class="left-arrow-image1">
              <img src="../../static/series/cutbed/arrow1.png" alt="">
            </div>
            <div class="left-arrow-image2">
              <img src="../../static/series/cutbed/arrow2.png" alt="">
            </div>
            <div class="left-arrow-image3">
              <img src="../../static/series/cutbed/arrow3.png" alt="">
            </div>
          </div>
        </div>

        <!-- 右侧文字区域 -->
        <div class="heat-right-text-container">
          <div class="text-top">
            <p class="text-top-second">{{ topSecondText }}</p>
          </div>
          <div class="text-bottom">
            <p class="text-bottom-second">
              <span class="text-block">{{$t('series.heat_desc')}}</span>
              <span class="text-block">{{$t('series.heat_desc1')}}</span>
              <span class="text-block">{{$t('series.heat_desc2')}}</span>
              <span class="text-block">{{$t('series.heat_desc3')}}</span>
              <span class="text-block">{{$t('series.heat_desc4')}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenteredVerticalImageText',
  props: {
    imageSrc: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: '竖形展示图片'
    },
    gradientFrom: {
      type: String,
      default: '#0066CC'
    },
    gradientTo: {
      type: String,
      default: '#66CCFF'
    },
    widthPercentage: {
      type: Number,
      default: 80,
      validator: (value) => value > 0 && value <= 100
    },
    textColor: {
      type: String,
      default: '#333333'
    }
  },
  data() {
    return {
      topFirstText: this.$i18n.t('series.heatwave'),
      topSecondText: this.$i18n.t('series.battleReady'),
      imageLoaded: false,
      isMobile: false
    };
  },
  methods: {
    handleImageLoad() {
      this.imageLoaded = true;
    },
    checkDevice() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  computed: {
    gradientStyle() {
      return {
        background: `linear-gradient(to right, ${this.gradientFrom}, ${this.gradientTo})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      };
    },
    containerWidth() {
      return `${this.widthPercentage}%`;
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);

    this.$nextTick(() => {
      const isMobile = this.isMobile;
      // 移动端调整初始位置参数
      const topTextX = isMobile ? '-5vw' : '-10vw';
      const topTextY = isMobile ? '-5vw' : '-10vw';
      const rightTextX = isMobile ? '5vw' : '10vw';
      const animationDuration = isMobile ? 1.2 : 1.5;
      const arrowMoveDistance = isMobile ? 30 : 50;

      this.$gsap.set('.heat-top-text', {
        y: topTextY,
        x: topTextX
      })
      this.$gsap.set('.heat-right-text-container', {
        x: rightTextX
      })

      this.$gsap.set([
        '.image-arrow4',
        '.left-arrow-image1',
        '.left-arrow-image2',
        '.left-arrow-image3'], {
        opacity: 0
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.heat-page-container',
          start: isMobile ? 'top 95%' : 'top 90%',
          end: isMobile ? 'bottom 30%' : 'bottom 20%',
          markers: false,
          toggleActions: 'play none none none'
        }
      })

      masterTimeline.from(['.heat-top-text', '.left-image-container'], {
        // opacity: 0,
        duration: animationDuration,
        y: isMobile ? 60 : 100,
        ease: 'power2.in'
      })

      const masterTimeline2 = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.heat-right-text-container',
          start: isMobile ? 'top 85%' : 'top 80%',
          end: isMobile ? 'bottom 30%' : 'bottom 20%',
          markers: false,
          toggleActions: 'play none none none'
        }
      })

      masterTimeline2.from('.heat-right-text-container', {
        // opacity: 0,
        duration: animationDuration,
        y: isMobile ? 60 : 100,
        ease: 'power2.in'
      })

      masterTimeline2.to(['.image-15'], {
        duration: animationDuration,
        y: isMobile ? -10 : -20,
        opacity: 0.5,
        ease: 'power2.in'
      }, isMobile ? 0.5 : 0.8)

      masterTimeline2.to('.image-arrow4', {
        duration: animationDuration,
        opacity: 1,
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)

      // 调整箭头动画距离，适应移动端
      masterTimeline2.to('.left-arrow-image1', {
        duration: animationDuration,
        opacity: 1,
        y: arrowMoveDistance,
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)

      masterTimeline2.to('.left-arrow-image2', {
        duration: animationDuration,
        opacity: 1,
        x: arrowMoveDistance,
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)

      masterTimeline2.to('.left-arrow-image3', {
        duration: animationDuration,
        opacity: 1,
        y: -arrowMoveDistance,
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)

      masterTimeline2.to('.text-top-second', {
        duration: animationDuration,
        color: "#808080",
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)

      masterTimeline2.to('.text-bottom-second', {
        duration: animationDuration,
        color: "#000",
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1.3)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  }
};
</script>

<style scoped>
.heat-page-container {
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  padding: 2rem 0;
  box-sizing: border-box;
  margin-top: 600px;
  position: relative;
}

.heat-container-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.split-container {
  width: v-bind(containerWidth);
  display: flex;
  gap: 2rem;
  align-items: center;
}

.left-image-container {
  flex: 1;
  height: 1200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  min-height: 500px;
  display: flex;
  justify-content: center;
  z-index: 3;
}

.vertical-image {
  height: auto;
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
}

.image-15 {
  z-index: 1;
  width: 160%;
}

.image-14 {
  z-index: 2;
  width: 88%;
  margin-left: 25px;
}

.heat-right-text-container {
  flex: 1.5;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 1rem 0;
}

.text-top {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.text-top-first {
  font-size: 3em;
  color: v-bind(textColor);
  margin: 0;
  line-height: 1.4;
  text-align: left;
}

.text-top-second {
  font-size: var(--font-size-xl);
  margin: 0;
  line-height: 1.2;
  text-align: left;
}

.text-bottom {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.text-bottom-first {
  font-size: 1.2em;
  color: v-bind(textColor);
  margin: 0;
  line-height: 1.6;
  text-align: left;
}

.text-bottom-second {
  font-size: var(--font-size-lg);
  color: #808080;
  margin: 0;
  line-height: 1.6;
  text-align: left;
}

.heat-top-text {
  width: auto;
  position: absolute;
  left: 50%;
  top: 0;

  span {
    font-size: var(--font-size-xl);
  }
}

.image-arrow4 {
  z-index: 1;
  margin-left: 60px;
}

.left-arrow-image {
  z-index: 2;
  width: 100%;
  height: 100%;
  position: absolute;
}

.left-arrow-image1 {
  position: absolute;
  left: 10%;
  top: 40%;

  img {
    width: 60%;
  }
}

.left-arrow-image2 {
  position: absolute;
  top: 69%;
  left: 45%;

  img {
    width: 60%;
  }
}

.left-arrow-image3 {
  position: absolute;
  left: 84%;
  top: 28%;

  img {
    width: 60%;
  }
}

/* 文本块样式 - 解决换行问题 */
.text-block {
  display: block;
  margin-bottom: 0.5em;
}

.text-block:last-child {
  margin-bottom: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .heat-page-container {
    margin-top: 300px; /* 减少顶部距离 */
    min-height: auto; /* 自适应高度 */
    padding: 1.5rem 0;
  }

  .split-container {
    flex-direction: column; /* 改为垂直布局 */
    gap: 2rem;
    padding: 0 5%;
    width: 100%;
  }

  /* 图片容器调整 */
  .left-image-container {
    width: 100%;
    flex: none;
    height: 600px; /* 减小高度 */
    min-height: 300px;
  }

  .vertical-image {
    width: 90% !important; /* 强制图片宽度 */
  }

  /* 箭头位置调整 */
  .image-arrow4 {
    margin-left: 30px; /* 减少左侧距离 */
    width: 65% !important; /* 调整箭头大小 */
  }

  .left-arrow-image1,
  .left-arrow-image2,
  .left-arrow-image3 {
    transform: scale(0.8); /* 缩小箭头 */
  }

  .left-arrow-image1 {
    left: 17%;
    top: 35%;
  }

  .left-arrow-image2 {
    width: 50%;
    top: 66%;
    left: 15%;
  }

  .left-arrow-image3 {
    left: 60%;
    top: 25%;
  }

  /* 文字区域调整 */
  .heat-right-text-container {
    width: 100%;
    flex: none;
    gap: 1.5rem;
    padding: 0 5%;
  }

  .heat-top-text {
    transform: translateX(-50%); /* 精确居中 */
    top: -20px; /* 调整顶部文字位置 */

    span {
      font-size: clamp(18px, 5vw, 24px);
    }
  }

  .text-top-second {
    font-size: clamp(20px, 6vw, 28px);
  }

  .text-bottom-second {
    font-size: clamp(14px, 4vw, 16px);
    line-height: 1.8; /* 增加行高 */
  }

  /* 文本块样式 - 解决换行问题 */
  .text-block {
    display: block;
    margin-bottom: 0em;
  }
}

@media (max-width: 480px) {
  .heat-page-container {
    margin-top: 200px;
  }

  .left-image-container {
    height: 400px; /* 进一步减小高度 */
  }

  .image-arrow4 {
    margin-left: 15px;
  }

  /* 箭头进一步缩小 */
  .left-arrow-image1,
  .left-arrow-image2,
  .left-arrow-image3 {
    transform: scale(0.6);
  }
}
</style>
